import { useEffect } from "react";

import { useRouter } from "next/router";
import { captureFbclid } from "../../utils/help/socialMediaPixels/metaClickIds";

/**
 * Stores the Meta click identifier when a visit arrives from an ad.
 *
 * `fbc` is half of what makes an event attributable to a campaign, and it only
 * exists in the browser -- Meta puts `fbclid` on the landing URL and nothing
 * captures it today. Runs on every route so a customer who lands on a deep link
 * is attributed the same as one who lands on the home page.
 *
 * The `fbclid` is deliberately left in the URL: Meta's own pixel reads it from
 * `location.search`, and rewriting the query here would fight the offer and table
 * parameter handling that also runs on mount.
 */
export const useMetaClickIds = () => {
  const router = useRouter();
  const fbclidParam = router.query?.fbclid;

  useEffect(() => {
    if (!router.isReady) {
      return;
    }

    captureFbclid(Array.isArray(fbclidParam) ? fbclidParam[0] : fbclidParam);
  }, [router.isReady, fbclidParam]);
};
